import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormGroup, FormControl} from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AssetService } from 'src/app/_services/asset.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobOrdersService } from "src/app/_services/job-orders.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { OnboardService } from "src/app/_services/onboard.service";
import { OnBoardProgressService } from 'src/app/_services/on-board-progress.service';
import moment from "moment-timezone";
import { INTERCOM_EVENT, IntercomService } from "src/app/_services/intercom.service";

@Component({
    selector: 'app-create-asset-jo',
    templateUrl: './create-asset-jo.component.html',
    styleUrls: ['./create-asset-jo.component.scss'],
    standalone: false
})
export class CreateAssetJoComponent implements OnInit {
  translate: any;
  addAssetJoForm!: FormGroup;
  data: any;
  statuses: any = [];
  types: any = [];
  jobOrderTypes: any = [];
  jobOrderStatuses: any = [];
  dateConfig: any; 

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private router: Router,
    private assetService: AssetService,
    private spinner: NgxSpinnerService,
    private jobOrderService: JobOrdersService,
    private errorUtil: ErrorUtil,
    private onboardService: OnboardService,
    private progressService: OnBoardProgressService,
    private intercomService: IntercomService
  ) {
    this.preInit();
   }

  ngOnInit(): void {
     this.languageTranslateService.wordSrc$.subscribe(transData => { 
          if(Object.keys(transData).length != 0){
            this.translate = transData
          }
      })

      this.dateConfig = {
        dateInputFormat: localStorage.getItem("date_format")!.toUpperCase(),
      };

      this.assetService.getStatuses(true).subscribe((res: any) => {
        const allStatus = res.body.filter((t: any) => t.active);
        this.statuses = allStatus.sort((elementA: any, elementB: any) => {
          if (elementA.order > elementB.order) {
            return 1;
          }

          if (elementA.order < elementB.order) {
            return -1;
          }

          return 0;
        });

        //const theDefault = allStatus.find((t: any) => t.isDefault === true);
      })

      this.assetService.getTypes(true).subscribe((res: any) => {
        const allTypes = res.body.filter((t: any) => t.active);
        this.types = allTypes.sort((elementA: any, elementB: any) => {
          if (elementA.order > elementB.order) {
            return 1;
          }

          if (elementA.order < elementB.order) {
            return -1;
          }

          return 0;
        });

        // const theDefault = allTypes.find((t: any) => t.isDefault === true);

        // if (theDefault) {
        //   this.asset.assetsType.id = theDefault.id;
        // }
      })

      this.jobOrderService.getJobOrderTypes(true).subscribe((res: any) => {
        this.jobOrderTypes = res?.filter((jot: any) => jot.active).sort((elementA: any, elementB: any) => {
          if (elementA?.order > elementB?.order) {
            return 1;
          }

          if (elementA?.order < elementB?.order) {
            return -1;
          }

          return 0;
        });

        // const theDefault = this.jobOrderTypes.find(
        //   (t: any) => t.isDefault === true
        // );
      })

      this.jobOrderService.getJobOrderStatuses().subscribe((res: any) => {
        this.jobOrderStatuses = res?.filter((jot: any) => jot.active).sort((elementA: any, elementB: any) => {
          if (elementA?.order > elementB?.order) {
            return 1;
          }

          if (elementA?.order < elementB?.order) {
            return -1;
          }
          return 0;
        });
        // const theDefault = this.jobOrderTypes.find(
        //   (t: any) => t.isDefault === true
        // );
      });
  }

  /******************************************** pre start ******************************************/
  private preInit() {
    this.addAssetJoForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      status: new FormControl('', [Validators.required]),
      serialNo: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      joType: new FormControl('', [Validators.required]),
      joStatus: new FormControl('', [Validators.required]),
      installationDate: new FormControl('', [Validators.required]),
      orderName: new FormControl('', [Validators.required])
    })}

  generateTemporarySerialNo(): void {
    const randomString = Math.random().toString(36).substring(2, 10); // Generate a random alphanumeric string
    this.addAssetJoForm.patchValue({
      serialNo:  `TEMP-${randomString}`
    })
  }
  
  /* From Import Asset */
  goToNextStep(){
      this.spinner.show();
      let params: any = {
        name: this.addAssetJoForm.get('name').value,
        assetsType: {id: this.addAssetJoForm.get('type').value},
        assetsStatus: {id: this.addAssetJoForm.get('status').value},
        serialNo: this.addAssetJoForm.get('serialNo').value,
      };

      this.assetService.createAsset(params).subscribe((res: any) => {
        if (res.status === 200 || res.status === 201) {
          this.intercomService.track(INTERCOM_EVENT.ASSET_CREATED);
          this.errorUtil.setErrorMessage(
            200,
            this.translate?.general.messages.savedSuccessfully ,
            null,
            "success",
            2000
          );

          //mark the step as done,
          this.progressService.markStepComplete('import-own-csv-asset');
          this.progressService.sendCurrentStepData(2);
          //then go to next step
          let stepObj: any = {onBoardingStep2: true};
          this.onSaveStep(stepObj);
          this.router.navigate(["dashboard/onBoard/import-own-csv-jo"]);
          //DO WE NEED TO TRACK OR NOT?
        }  else {

          var errorTitle = res.error.title
          if (res.error.type == 'dynamic-lang-error') {
            var data = res.error.instance + ".validationBE." + res.error.detail;
            var message = this.languageTranslateService.getNestedValue(this.translate, data);
            errorTitle = message
          }

          this.errorUtil.setErrorMessage(
            res.status,
            null,
            errorTitle,
            "error",
            2000
          );
        }
        this.spinner.hide();
        this.modalRef.hide();
      }, (err) => {
        console.log(err)
        this.spinner.hide();
       const title = this.errorUtil.processErrorTitle(err.error,this.translate)
       this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
      })
  }
  /* From Import Work Order */
  goToLearnMore(){
      this.spinner.show();
      let params: any = {
        jobOrder:{
          jobOrderName: this.addAssetJoForm.get('orderName').value,
          jobOrderType: {id: this.addAssetJoForm.get('joType').value},
          status: this.addAssetJoForm.get('joStatus').value,
          installationDate: this.addAssetJoForm.get('installationDate').value,
        }
      };

      if (
        params.jobOrder.installationDate &&
        params.jobOrder.installationDate != ""
      ) {

        let installDate: any = params.jobOrder.installationDate;
        params.jobOrder['installationTime'] = installDate.toISOString();

        params.jobOrder.installationDate = moment(
          params.jobOrder.installationDate,
          this.dateConfig.dateInputFormat
        )
          .format("YYYY-MM-DD")
          .toString();
      }
      
      this.jobOrderService.createJobOrder(params).subscribe((res: any) => {

        if (res.status === 200 || res.status === 201) {
          this.intercomService.track(INTERCOM_EVENT.JO_CREATED);
          this.errorUtil.setErrorMessage(
            200,
            this.translate?.general.messages.savedSuccessfully ,
            null,
            "success",
            2000
          );

          //mark the step as done,
          this.progressService.markStepComplete('import-own-csv-jo');
          this.progressService.sendCurrentStepData(3);
          //then go to next step
          let stepObj: any = {onBoardingStep3: true};
          this.onSaveStep(stepObj);
          this.router.navigate(["dashboard/onBoard/invite-team"]);//invite team is step 4 (new changes)
          //DO WE NEED TO TRACK OR NOT?
        }  else {

          var errorTitle = res.error.title
          if (res.error.type == 'dynamic-lang-error') {
            var data = res.error.instance + ".validationBE." + res.error.detail;
            var message = this.languageTranslateService.getNestedValue(this.translate, data);
            errorTitle = message
          }

          this.errorUtil.setErrorMessage(
            res.status,
            null,
            errorTitle,
            "error",
            2000
          );
        }
        this.spinner.hide();
        this.modalRef.hide();
      }, (err) => {
        console.log(err)
        this.spinner.hide();
       const title = this.errorUtil.processErrorTitle(err.error,this.translate)
       this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
      })
     
  }

  
  onSaveStep(step: any){
    this.onboardService.saveOnboardingSteps(step).subscribe((res: any) => {
      if (res.status === 200) {
        this.errorUtil.setErrorMessage(
          200,
          this.translate?.general.messages.savedSuccessfully,
          null,
          "success",
          2000
        );
      }
    },
      (error) => {
        console.log(error);
        this.spinner.hide();
        var body = JSON.parse(error._body);
        this.errorUtil.setErrorMessage(400, null, body.detail.title, 'error', 3000);
      }
    );
  }
}
